<!-- <ng-container [formArrayName]="'Payments'">
    <ng-container [formGroupName]="'0'">
        
    </ng-container>
</ng-container> -->
<div class="flex flex-row grow gap-4 justify-between">
    <z-dcl-provided-service-category-selector
        class="w-6"
    ></z-dcl-provided-service-category-selector>
    <z-select
        class="w-6"
        id="{{ id() }}"
        [options]="options()"
        [style]="inputStyle()"
        [optionLabel]="optionLabel()"
        [optionValue]="optionValue()"
        [placeholder]="placeholder()"
        [label]="label()"
        [filter]="false"
        [showClear]="true"
        [readonly]="
            rootFormGroup?.form?.controls?.['CompletionDateTime']?.value !=
            undefined
        "
        formControlName="OffSiteProvidedService"
        (ngModelChange)="onModelChange($event)"
    />
</div>
<div class="flex flex-row grow gap-4">
    <div class="flex w-6"></div>
    @if (
        rootFormGroup?.form?.controls?.['OffSiteProvidedService']?.value == 1
    ) {
        <z-float-label
            class="w-6"
            [label]="'Α.Φ.Μ Συνεργαζόμενης Οντότητας'"
            [formControlName]="'CooperatingVatNumber'"
            [readonly]="
                rootFormGroup?.form?.controls?.['CompletionDateTime']?.value !=
                undefined
            "
        ></z-float-label>
    }

    @if (
        rootFormGroup?.form?.controls?.['OffSiteProvidedService']?.value == 2
    ) {
        <z-branch-select
            class="w-6"
            [formControlName]="'BranchOtherId'"
            [autoSelectBranch]="true"
            [readonly]="
                rootFormGroup?.form?.controls?.['CompletionDateTime']?.value !=
                undefined
            "
        ></z-branch-select>
    }
</div>
